const bankTwo = [
    {
      id: 10,
      triggerKey: "Q",
      clipName: "Chord-1",
      clipUrl: "https://s3.amazonaws.com/freecodecamp/drums/Chord_1.mp3"
    },
    {
      id: 11,
      triggerKey: "W",
      clipName: "Chord-2",
      clipUrl: "https://s3.amazonaws.com/freecodecamp/drums/Chord_2.mp3"
    },
    {
      id: 12,
      triggerKey: "E",
      clipName: "Chord-3",
      clipUrl: "https://s3.amazonaws.com/freecodecamp/drums/Chord_3.mp3"
    },
    {
      id: 13,
      triggerKey: "A",
      clipName: "Shaker",
      clipUrl: "https://s3.amazonaws.com/freecodecamp/drums/Give_us_a_light.mp3"
    },
    {
      id: 14,
      triggerKey: "S",
      clipName: "Open-HH",
      clipUrl: "https://s3.amazonaws.com/freecodecamp/drums/Dry_Ohh.mp3"
    },
    {
      id: 15,
      triggerKey: "D",
      clipName: "Closed-HH",
      clipUrl: "https://s3.amazonaws.com/freecodecamp/drums/Bld_H1.mp3"
    },
    {
      id: 16,
      triggerKey: "Z",
      clipName: "Punchy-Kick",
      clipUrl: "https://s3.amazonaws.com/freecodecamp/drums/punchy_kick_1.mp3"
    },
    {
      id: 17,
      triggerKey: "X",
      clipName: "Side-Stick",
      clipUrl: "https://s3.amazonaws.com/freecodecamp/drums/side_stick_1.mp3"
    },
    {
      id: 18,
      triggerKey: "C",
      clipName: "Snare",
      clipUrl: "https://s3.amazonaws.com/freecodecamp/drums/Brk_Snr.mp3"
    }
  ];
  
  export default bankTwo;